import { render, staticRenderFns } from "./compareInfo.vue?vue&type=template&id=ab87b406&scoped=true&"
import script from "./compareInfo.vue?vue&type=script&lang=js&"
export * from "./compareInfo.vue?vue&type=script&lang=js&"
import style0 from "./compareInfo.vue?vue&type=style&index=0&id=ab87b406&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab87b406",
  null
  
)

export default component.exports